import { Order } from 'components/Checkout/types';
import { useFlags } from 'gatsby-plugin-launchdarkly';
import { useQueryParam } from 'use-query-params';
import { Flags } from 'utils/constants/featureFlags';
import { VARIANT_SKUS } from 'utils/constants/products';
import { QUERY_PARAMS } from 'utils/constants/queryParams';
import { LineItem } from 'utils/types';

export const isCovidOnCoreCheckout = (): boolean => {
  const [covidCoreCheckoutQueryParam] = useQueryParam<string>(
    QUERY_PARAMS.covidCoreCheckout,
  );

  const flags = useFlags();

  return (
    flags[Flags.CovidCoreCheckout] || covidCoreCheckoutQueryParam === 'true'
  );
};

export const includesCovidDTC = (lineItems: LineItem[] | undefined): boolean =>
  !!lineItems?.some((item) => item.variant_sku === VARIANT_SKUS.COVID);
